var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Bt=require("ttag");module.exports=$CLJS.Bt;